import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { VehicleFields } from "@/pages/ClientDetail";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = (client_id) => ({ client_id, make: "", model: "", version: "", year: "", plate: "", color: "", mileage: "", vehicle_type: "", notes: "", photos: [] });

export default function QuickVehicleDialog({ open, setOpen, clientId, onCreated }) {
  const [form, setForm] = useState(EMPTY(clientId));
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm(EMPTY(clientId)); }, [open, clientId]);

  const save = async () => {
    if (!form.make) return toast.error("La marque est requise");
    setSaving(true);
    try {
      const { data } = await api.post("/vehicles", { ...form, client_id: clientId });
      toast.success("Véhicule ajouté");
      setOpen(false);
      onCreated(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-white border-slate-200 max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="quick-vehicle-dialog">
        <DialogHeader><DialogTitle className="text-slate-900">Ajouter un véhicule au client</DialogTitle></DialogHeader>
        <VehicleFields form={form} setForm={setForm} />
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} className="border-slate-200">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="quick-vehicle-save" className="bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">{saving && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
